import constants from "../../constants";
import { useContext, useState } from "react";
import AlertContext from "../../context/AlertContext";
import { LibraryContext } from "../../context/LibraryContext";

export default function ModulesHooks() {
  const Alert = useContext(AlertContext);
  const LibraryCxt = useContext(LibraryContext);

  let [Errors, setErrors] = useState({
    url: "",
    marks: "",
    maxtime: "",
    exampleio: "",
    testcaseio: "",
    oursolution: "",
    boilerplate: "",
    language: "java",
    executioncode: "",
    difficulty: "easy",
    problemstatement: "",
  });

  const [makeStableState, setMakeStableState] = useState(false);

  const handleInputChange = (event, name) => {
    if (event.name === "topicname") {
      let tempUsrInp =
        Alert.tableShowStatus === constants.libTypeIds.SQL
          ? Alert.testDetail
          : LibraryCxt.userInput;

      if (tempUsrInp.hasOwnProperty("topic")) {
        delete tempUsrInp.topic;
      }

      Alert.setTestDetail({
        result: "",
        ...tempUsrInp,
        success: true,
      });

      LibraryCxt.setUserInp({
        result: "",
        ...tempUsrInp,
        success: true,
      });
    } else if (event.name === "topic") {
      let tempUsrInp =
        Alert.tableShowStatus === constants.libTypeIds.SQL
          ? Alert.testDetail
          : LibraryCxt.userInput;

      if (tempUsrInp.hasOwnProperty("topicname")) {
        delete tempUsrInp.topicname;
      }

      Alert.setTestDetail({
        result: "",
        success: true,
        ...tempUsrInp,
      });

      LibraryCxt.setUserInp({
        result: "",
        success: true,
        ...tempUsrInp,
      });
    } else if (name === "complexity") {
      Alert.setTestDetail({
        result: "",
        ...Alert.testDetail,
        success: true,
        [name]: event.value,
      });

      LibraryCxt.setUserInp({
        result: "",
        ...LibraryCxt.userInput,
        success: true,
        [name]: event.value,
      });

      LibraryCxt.setLevel({ name: event.label, value: event.value });
    } else if (name === "name") {
      Alert.setTestDetail({
        ...Alert.testDetail,
        result: "",
        success: true,
        ["name"]: event,
      });

      LibraryCxt.setUserInp({
        ...LibraryCxt.userInput,
        result: "",
        success: true,
        ["name"]: event,
      });
    } else if (name === "description") {
      Alert.setTestDetail({
        result: "",
        ...Alert.testDetail,
        success: true,
        ["description"]: event,
      });

      LibraryCxt.setUserInp({
        result: "",
        ...LibraryCxt.userInput,
        success: true,
        ["description"]: event,
      });
    } else if (name === "ansexp") {
      Alert.setTestDetail({
        result: "",
        ...Alert.testDetail,
        success: true,
        ["ansexp"]: event,
      });

      LibraryCxt.setUserInp({
        result: "",
        ...LibraryCxt.userInput,
        success: true,
        ["ansexp"]: event,
      });
    } else {
      const target = event.target;
      const name = target.name;
      let value = target.value;

      if (name === "marks" || name === "maxtime") {
        value = value.trim();
        value = value.replace(/\D/g, "");
        if (value === "") {
          setErrors({
            ...Errors,
            success: false,
            marks: "Please enter a valid value",
          });
          value = 0;
        } else if (isNaN(+value)) {
          setErrors({
            ...Errors,
            success: false,
            marks: "Please enter only numbers",
          });
        } else if (+value <= 0) {
          setErrors({
            ...Errors,
            success: false,
            marks: "Please enter only positive numbers",
          });
          value = "";
        } else {
          setErrors({ ...Errors, marks: "", success: true });
          value = "" + (+value);
        }
        if (Alert.tableShowStatus === constants.libTypeIds.ASSIGNMENT) {
          value = value * 60;
        }
      }
       Alert.setTestDetail({
        ...Alert.testDetail,
        result: "",
        [name]: value,
        success: true,
      });

      LibraryCxt.setUserInp({
        ...LibraryCxt.userInput,
        result: "",
        [name]: value,
        success: true,
      });
    }

    if (Alert.isqueReport && !makeStableState) {
      setMakeStableState(true);
    } else if (Alert.isqueReport && makeStableState) {
      Alert.setIsStableState(false);
    }
  };

  return { handleInputChange };
}
